// extracted by mini-css-extract-plugin
export default {"buttonsWrap":"components_buttonsWrap__ybL45"};